import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const awardWallet = defineConnector({
  identifier: "awardWallet",
  name: "AwardWallet",
  tagLine: "Loyalty and frequent flyer account tracking",
  keywords: "awardwallet loyalty miles points frequent flyer rewards balances",
  logo,
  protocol: "http",
  tags: ["travel"],
  defaultUrlPattern: () =>
    domainToRegex("business.awardwallet.com/api/export/v1"),
  auth: (app) =>
    headerAuth([{ name: "X-Authentication", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Request AwardWallet API access",
      items: [
        {
          kind: "markdown",
          content:
            "Apply for the Account Access API at [business.awardwallet.com/api](https://business.awardwallet.com/api/) — AwardWallet issues the key once your use case is approved.",
        },
      ],
    },
    {
      title: "Paste your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () =>
      "https://business.awardwallet.com/api/export/v1/connectedUsers",
  },
});
